import { useEffect } from 'react';

// Clics qui ne font pas quitter l'édition d'une cellule : la section
// « Insertion » du panel de droite (CellInsertionPanel, data-cell-insertion)
// et le sélecteur d'emoji qu'elle ouvre, rendu dans un portail hors de la
// cellule comme du panel. Sans cette exception, le mousedown démontait la
// section avant que le clic n'atteigne son bouton : rien n'était inséré.
//
// Le reste du panel (lignes, colonnes, fusion…) garde l'ancien comportement :
// ces actions réécrivent le tableau, la cellule doit d'abord enregistrer son
// texte et relire le contenu du store, faute de quoi elle réécrirait plus tard
// son ancien texte par-dessus.
const KEEP_EDITING_SELECTOR = [
  '[data-cell-insertion="true"]',
  '.emoji-picker-popover',
  '.emoji-picker-tabs-more-dropdown',
  // Pastille « Conserver uniquement le texte » après un collage.
  '.RichEditor-paste-choice',
].join(', ');

export const useCellClickOutside = ({ ref, isSelected, enabled = true, onClickOutside }) => {
  useEffect(() => {
    if (!enabled || !isSelected) return undefined;
    const handleMouseDown = (event) => {
      if (!ref.current || ref.current.contains(event.target)) return;
      if (event.target?.closest?.(KEEP_EDITING_SELECTOR)) return;
      onClickOutside();
    };
    document.addEventListener('mousedown', handleMouseDown);
    return () => document.removeEventListener('mousedown', handleMouseDown);
  }, [ref, isSelected, enabled, onClickOutside]);
};
